import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "testimonial-single-item" }
const _hoisted_2 = { class: "d-flex align-items-center mb-32" }
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "flex-grow-1 ms-4" }
const _hoisted_6 = { class: "ps-0 list-unstyled d-flex align-items-center gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createBlock(_component_Swiper, {
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    preventClicks: true,
    loop: true,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    navigation: {
      prevEl: '.prev2',
      nextEl: '.next2',
    },
    modules: _ctx.modules,
    class: "reviews-slide position-relative"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.testimonials, (testimonial, index) => {
        return (_openBlock(), _createBlock(_component_SwiperSlide, { key: index }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: testimonial.image,
                    class: "rounded-circle",
                    alt: "testimonial"
                  }, null, 8, _hoisted_4)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("ul", _hoisted_6, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (star) => {
                      return _createElementVNode("li", { key: star }, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("i", { class: "ti ti-star-filled" }, null, -1)
                      ]))])
                    }), 64))
                  ]),
                  _createElementVNode("h3", null, _toDisplayString(testimonial.name), 1)
                ])
              ]),
              _createElementVNode("p", null, _toDisplayString(testimonial.message), 1)
            ])
          ]),
          _: 2
        }, 1024))
      }), 128)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "testomonial-controller" }, [
        _createElementVNode("div", { class: "controller-icon prev2" }, [
          _createElementVNode("i", { class: "ti ti-arrow-left" })
        ]),
        _createElementVNode("div", { class: "controller-icon next2" }, [
          _createElementVNode("i", { class: "ti ti-arrow-right" })
        ])
      ], -1))
    ]),
    _: 1
  }, 8, ["modules"]))
}